import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const variants = cva('', {
  variants: {
    variant: {
      boxed: 'px-2 md:px-0 w-full max-w-6xl mx-auto',
      full: 'px-2 md:px-0 w-full',
    },
    size: {
      default: '',
      sm: '',
      lg: '',
      icon: '',
    },
  },
  defaultVariants: {
    variant: 'full',
    size: 'default',
  },
});

export interface SectionProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof variants> {}

const Section = React.forwardRef<HTMLDivElement, SectionProps>(({ className, variant, size, ...props }, ref) => {
  return <section className={cn(variants({ variant, size, className }))} ref={ref} {...props} />;
});
Section.displayName = 'Section';

export { Section, variants };
